import { render } from "./Index.vue?vue&type=template&id=5d21e55d"
import script from "./Index.vue?vue&type=script&setup=true&lang=js"
export * from "./Index.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Retours/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d21e55d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d21e55d', __exports__)) {
    api.reload('5d21e55d', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=5d21e55d", () => {
    api.rerender('5d21e55d', render)
  })

}


export default __exports__